import { Paper } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import LinkIcon from '@material-ui/icons/Link'
import { withSnackbar } from 'notistack'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Link, useHistory, withRouter } from 'react-router-dom'
import ChapterForm from '../../components/chapter/ChapterForm'
import { withEpisodes } from '../../contexts/data-context'
import Helper from '../../utils/Helper'
import { doAndSnack } from '../../utils/snackbar'
import { chapterDetailStyle as styles } from './styles'

const ChapterDetail = (props: any) => {
  const { classes, enqueueSnackbar, match } = props
  const [chapter, setChapter]: any = useState({})
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true)

  const fetchData = async () => {
    // race condition problem for slug
    let { slug } = match.params
    if (chapter && chapter.slug) slug = chapter.slug
    const [data] = await Helper.ApiRequest(`/chapters?slug=${slug}`)
    setChapter(data)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const saveChapter = async () => {
    const { isFree, episode, slug, title } = chapter

    if (!episode) {
      enqueueSnackbar('Please link chapter with an episode', {
        variant: 'error',
      })
      return
    }
    if (!title) {
      enqueueSnackbar('Title is required!', {
        variant: 'error',
      })
      return
    }

    if (!slug) {
      enqueueSnackbar('Slug is required!', {
        variant: 'error',
      })
      return
    }

    if (episode && isFree) {
      if (!episode.isFree) {
        enqueueSnackbar('You cannot link free chapter with paid episode.', {
          variant: 'error',
        })
        return
      }
    }

    const [promise, onSuccess] = await getSaveRequest(chapter)
    doAndSnack(promise, enqueueSnackbar, {
      success: 'Chapter successfully saved',
      fail: 'Failed to save chapter',
      onSuccess,
    })
  }

  const getSaveRequest = (chapter) => {
    const { _id, slug } = chapter
    const path = `/chapters/${_id}`
    const method = 'PUT'
    const body = JSON.stringify(chapter)
    const promise = Helper.ApiRequest(path, {
      method,
      body,
    })

    const onSuccess = () => {
      history.push(`/chapters/${slug}`)
      fetchData()
    }
    return [promise, onSuccess]
  }

  const handleChange = (data) => {
    setChapter({
      ...data,
    })
  }

  return (
    <>
      <FormTitle episode={chapter.episode} />
      <Paper className={classes.paper}>
        {!isLoading && (
          <ChapterForm
            // @ts-expect-error legacy
            chapter={chapter}
            onChange={handleChange}
            onSave={saveChapter}
          />
        )}
      </Paper>
    </>
  )
}

ChapterDetail.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withSnackbar(
  // @ts-expect-error legacy
  withEpisodes(withRouter(withStyles(styles)(ChapterDetail))),
)

function FormTitle({ episode }) {
  const { title, slug } = episode || {}

  return (
    <Typography component="h2" variant="h4" align="center">
      Episode Title : {title}
      <Link to={`/episodes/${slug}/chapters`}>
        <LinkIcon />
      </Link>
    </Typography>
  )
}
